import { render, staticRenderFns } from "./relatedTest.vue?vue&type=template&id=fe056860&scoped=true&"
import script from "./relatedTest.vue?vue&type=script&lang=js&"
export * from "./relatedTest.vue?vue&type=script&lang=js&"
import style0 from "./relatedTest.vue?vue&type=style&index=0&id=fe056860&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe056860",
  null
  
)

export default component.exports